import React from "react";
import { Link } from "react-router-dom";
import logoSVG from "../images/logo.svg";
import { useI18n } from "../i18n";

const Logo = () => {
  const { prefix } = useI18n();

  return (
    // Le logo doit ramener à l'accueil de la langue courante, pas au FR.
    <Link to={prefix || "/"} className="logo" title="Stéphane Nkengue — snkode">
      <img src={logoSVG} alt="snkode" width="40" height="40" />
      <h5>SNKODE</h5>
    </Link>
  );
};

export default Logo;
